import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureFlagDialogComponent } from './feature-flag-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		GoMaterialModule,
		A11yModule
	],
	declarations: [
		FeatureFlagDialogComponent
	],
	exports: [
		FeatureFlagDialogComponent
	]
})
export class FeatureFlagDialogComponentModule {}
